import { render, staticRenderFns } from "./Myreportshipscore.vue?vue&type=template&id=7c1790ac&scoped=true"
import script from "./Myreportshipscore.vue?vue&type=script&lang=js"
export * from "./Myreportshipscore.vue?vue&type=script&lang=js"
import style0 from "./Myreportshipscore.vue?vue&type=style&index=0&id=7c1790ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1790ac",
  null
  
)

export default component.exports